/**
 * @description An event for Dealer Lot component to retrieve App data in order to fetch relevant inventory
 * @example
 * window.CAIEventBus.on('elot:get-app-data', function(callback) {
 *    callback({
 *       zip: ...
 *    })
 * })
 */
export const ELOT_GET_DATA = 'elot:get-app-data';

/**
 * @description Triggered when GA/Pixall tags are sent
 * @returns Data for Analytics
 * @example
 * window.CAIEventBus.on('elot:analytics', function({ action, data }) { ... })
 */
export const ELOT_ANALYTICS = 'elot:analytics';

/**
 * @description Triggered when a listing is saved
 * @returns Saved listing data
 * @example
 * window.CAIEventBus.on('elot:saveListing', function(listing) { ... })
 */
 export const ELOT_SAVE_LISTING = 'elot:save';

/**
 * @description Triggered when a listing is unsaved
 * @returns Unsaved listing data
 * @example
 * window.CAIEventBus.on('elot:unsaveListing', function(listing) { ... })
 */
 export const ELOT_UNSAVE_LISTING = 'elot:unsave';

/**
 * @description An event for Dealer Lot component to retrieve App data and fetch new data
 * @example
 * window.CAIEventBus.listen(ELOT_UPDATE_LISTINGS, function(appData) { ... })
 */
export const ELOT_UPDATE_LISTINGS = 'elot:update-listings';
